import { render, staticRenderFns } from "./LongVehicleObject.vue?vue&type=template&id=3e3c3802&lang=pug&"
import script from "./LongVehicleObject.vue?vue&type=script&lang=ts&"
export * from "./LongVehicleObject.vue?vue&type=script&lang=ts&"
import style0 from "./LongVehicleObject.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports